export default __webpack_public_path__ + "static/media/info_blue.d2c11f7e.svg";